var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.434,
    height: 22.086,
    viewBox: "0 0 24.434 22.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x-social-media-black-icon",
    d: "M19.243,0H22.99L14.8,9.356l9.63,12.731h-7.54l-5.905-7.721L4.232,22.086H.482L9.237,12.079,0,0H7.731l5.338,7.057ZM17.928,19.844H20L6.6,2.125H4.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.80711d954d3f96f679b125b662ca43e4.svg";
export { ForwardRef as ReactComponent };